<template>
  <div class="panel-simple">
    <ValidationObserver ref="observer" novalidate>
      <div
        :id="'add-document-modal' + cmpIndex"
        class="modal fade"
        tabindex="-1"
        role="dialog"
      >
        <add-backup-document-modal
          :studentSieId="studentSieIdProp"
          :discipline-type-list="disciplineTypeList"
          @handleDocumentInfo="handleDocumentInfo"
          :objKey="cmpIndex"
        />
      </div>
      <div v-if="file.tempFileUpload.files.length == 0">
        <div class="bg-add-panel mb-4 mt-n3">
          <div class="col-md-12 col-sm-12 text-center">
            Al momento el estudiante no cuenta con documento de respaldo
          </div>
        </div>
      </div>
      <div v-else>
        <document-layout
          v-for="(fil, index) in file.tempFileUpload.files"
          :key="`${index}-${fil.disciplineTypeName}`"
          :actions="actionsFiltered"
          :in-server="fil.inServer"
          :node="index"
        >
          <div slot="firstColumn">
            <div class="row pt-2">
              <div class="col-md-12 col-sm-12 text-left">
                <div class="font-weight-normal font-14 color-gray--6">
                  Tipo de Servicio:
                </div>
                <p>
                  {{ file.tempFileUpload.types[index].serviceTypeName }}
                </p>
              </div>
            </div>
          </div>
          <div slot="secondColumn">
            <div class="row pt-2">
              <div class="col-md-12 col-sm-12 text-left">
                <div class="font-weight-normal font-14 color-gray--6">
                  Servicio:
                </div>
                <p>
                  {{ file.tempFileUpload.types[index].disciplineTypeName }}
                </p>
              </div>
            </div>
          </div>
          <div slot="thirdColumn">
            <div class="row pt-2">
              <div class="col-md-12 col-sm-12 text-left">
                <div class="font-weight-normal font-14 color-gray--6">
                  Fecha:
                </div>
                <span>
                  {{ file.tempFileUpload.types[index].documentRawDate | date }}
                </span>
              </div>
            </div>
          </div>
        </document-layout>
      </div>
      <div v-if="!readOnly" class="col-12 text-right bg-white pt-4">
        <div class="mx-0 bd-highlight ml-2">
          <ActionButton
            v-if="!disabled"
            class="mr-2"
            variant="success"
            i="fas fa-file-edit"
            @click="selectedEvaluationsModalOpen"
          >
            Modificar
          </ActionButton>
          <ActionButton
            v-if="!disabled"
            id="btnAddDocument"
            variant="success"
            :data-target="'#add-document-modal' + cmpIndex"
            data-toggle="modal"
            data-backdrop="static"
            i="fas fa-file-plus"
          >
            A&ntilde;adir
          </ActionButton>
        </div>
      </div>
    </ValidationObserver>
    <CustomAddRemoveListPopup
      ref="selectedEvaluationsModalRef"
      object-key="value"
      object-description="text"
      title="Selección Documentos de Respaldo"
      added-column-description="Documentos Seleccionados"
      removed-column-description="Documentos Disponibles"
      add-all-description="Seleccionar Todas"
      remove-all-description="Remover Todas"
      :added-list="computedAdded"
      :removed-list="computedAvailableListDocument"
      :btn-classes="'hidden'"
      @updated="docUpdateList"
    />
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomFileInput from 'CustomFileInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DocumentLayout from './DocumentLayout';
import ActionButton from 'ActionButton';
import general from '@/services/pei/general';
import CustomDropDown from 'custom-drop-down';
import CustomAlert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import AddBackupDocumentModal from './AddBackupDocumentModal';
import serviceTypes from '@/utils/constants/service-types';
import CustomAddRemoveListPopup from '@/components/common/CustomAddRemoveListPopup';
import transitionStudentService from '@/services/pei/transitionStudent.js';
import moment from 'moment';
export default {
  name: 'BackupDocument',
  components: {
    AddBackupDocumentModal,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    DocumentLayout,
    ActionButton,
    CustomDropDown,
    CustomAddRemoveListPopup,
  },
  props: {
    transitionStudentId: {
      type: Number,
      default: () => null,
    },
    areaId: {
      type: Number,
      default: () => null,
    },
    subAreaId: {
      type: Number,
      default: () => null,
    },
    documents: {
      type: Object,
      default: () => null,
    },
    studentSieIdProp: {
      type: Number,
      default: () => null,
    },
    documentTypes: {
      type: Array,
      default: () => [
        { id: 1, name: 'Evaluación' },
        { id: 2, name: 'Minuta' },
      ],
    },
    errorMsgs: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    show: {
      type: Number,
      default: () => null,
    },
    centerTitleHeader: {
      type: String,
      default: '',
    },
    objKey: {
      type: Number,
      default: () => null,
    },
    readOnly: {
      type: Boolean,
      dafault: () => false,
    },
  },
  data() {
    return {
      disciplineTypeList: [],
      alternaDocuments: [],
      availableDocumentBackup: [],
      file: {
        name: '',
        types: this.documentTypes
          ? this.documentTypes
          : [
              { id: 1, name: 'Evaluación' },
              { id: 2, name: 'Minuta' },
            ],
        allowedFiles: '.pdf',
        attachment: null,
        documentActions: [
          {
            icon: 'fa fa-download green-icon',
            name: 'Ver Documento',
            click: this.downloadFile,
            disabledOnView: false,
          },
          {
            icon: 'fa fa-times-circle text-red',
            name: 'Remover Documento',
            click: this.drop,
            disabledOnView: true,
          },
        ],
        tempFileUpload: {
          files: [],
          types: [],
        },
        typeSelected: null,
      },
      modal: {
        icon: 'fa fa-exclamation-triangle',
        size: 200,
        title: 'Alerta!',
        type: 'confirm',
        message: '',
        checkbox: {
          isRequired: false,
        },
        success: () => {},
        cancel: () => {},
      },
      showUpload: false,
      showMessageDocumentType: false,
      resources: [],
    };
  },
  methods: {
    async handleDocumentInfo(info) {
      const jsonObject = {};
      info.forEach((value, key) => {
        jsonObject[key] = value;
      });
      let isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.file.tempFileUpload.files.push(jsonObject.attachment);
      this.file.tempFileUpload.types.push({
        documentDate: jsonObject.documentDate,
        documentRawDate: jsonObject.documentDate,
        disciplineTypeName: jsonObject.disciplineTypeName,
        disciplineTypeId: parseInt(jsonObject.disciplineTypeId),
        documentTypeId: parseInt(jsonObject.documentTypeId),
        comment: jsonObject.description,
        administrator: jsonObject.administeredBy,
        serviceTypeName: jsonObject.serviceTypeName,
        status: jsonObject.status,
      });

      this.alternaDocuments.push({
        inServer: false,
        documentDate: jsonObject.documentDate,
        attachment: jsonObject.attachment,
        documentRawDate: jsonObject.documentDate,
        disciplineTypeName: jsonObject.disciplineTypeName,
        disciplineTypeId: jsonObject.disciplineTypeId,
        documentTypeId: jsonObject.documentTypeId,
        comment: jsonObject.description,
        adminBy: jsonObject.administeredBy,
        text:
          moment(jsonObject.documentDate).format('DD/MMM/YYYY') +
          ' -' +
          jsonObject.disciplineTypeName,
        value: `${this.alternaDocuments.length}`,
        serviceTypeName: jsonObject.serviceTypeName,
        status: jsonObject.status,
      });
      this.showUpload = false;
      this.$emit('files', this.file.tempFileUpload);
      this.clear();
    },
    async getDisciplineTypeList() {
      await transitionStudentService
        .getDisciplineByTypes({
          serviceTypeIds: [
            serviceTypes.EvaluacionInicial,
            serviceTypes.EvaluacionAdicional,
            serviceTypes.PruebasAcademicas,
            serviceTypes.PruebasAcademicasConDocumento,
          ],
        })
        .then((res) => {
          this.disciplineTypeList = res.map((x) => ({
            ...x,
            fullName: x.name + ' - ' + x.serviceTypeName,
          }));
        });
    },
    cancelDocument() {
      this.clear();
      this.showUpload = false;
    },
    setSelected(data) {
      this.file.typeSelected = data;
    },
    async save() {
      let isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.file.tempFileUpload.files.push(this.file.attachment);
      this.file.tempFileUpload.types.push(this.file.typeSelected.id);
      this.showUpload = false;
      this.$emit('files', this.file.tempFileUpload);
      this.clear();
    },
    clear() {
      this.file.typeSelected = null;
      this.file.attachment = null;
    },
    downloadFile(e) {
      let node = e.target.getAttribute('data-node');
      let file = this.file.tempFileUpload.files[node];

      if (!file.inServer) {
        let fileAttarchmen = !file.attachment ? file : file.attachment;
        general.documentDownloadLocalFile(fileAttarchmen);
      } else {
        let uri = `api/documents/downloaddocument?id=${file.id}`;

        this.$ApiGet(uri).then((response) => {
          general.downloadDocument(response.data);
        });
      }
    },
    async drop(e) {
      let alertResponse = await CustomAlert.methods.ShowCancelModal(
        'Atención',
        this.resources['R90006'],
        'Sí',
        'No'
      );

      if (alertResponse) {
        let index = e.target.getAttribute('data-node');
        const documentDetails = this.file.tempFileUpload.files[index] ?? {};

        let isDocumentDeletedFromServer = false;
        if (documentDetails?.inServer && documentDetails?.id) {
          this.$emit('remove', documentDetails.id);
          isDocumentDeletedFromServer = true;
        }

        this.file.tempFileUpload.files.splice(index, 1);
        this.file.tempFileUpload.types.splice(index, 1);
        this.alternaDocuments.splice(index, 1);

        // already emitted the remove event, so return
        if (isDocumentDeletedFromServer) return;
      }

      this.$emit('remove');
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '150',
        '22124',
        'R90006',
      ]);
    },
    async getDocumentsSelected() {
      const {
        data: response,
      } = await transitionStudentService.getSelectedDocuments(
        this.transitionStudentId,
        this.areaId,
        this.subAreaId
      );
      response.forEach((val) => {
        this.file.tempFileUpload.types.push({
          documentId: val.studentEvaluationsDocumentIds,
          documentDate: val.documentDate,
          documentRawDate: val.documentDate,
          disciplineTypeName: val.disciplineTypeName,
          disciplineTypeId: val.disciplineTypeId,
          documentTypeId: val.documentTypeId,
          comment: val.comment,
          administrator: val.adminBy,
          serviceTypeName: val.serviceTypeName,
          status: val.status,
        });
        this.file.tempFileUpload.files.push({
          id: val.studentEvaluationsDocumentIds,
          inServer: true,
          documentDate: val.documentDate,
          documentRawDate: val.documentDate,
          disciplineTypeName: val.disciplineTypeName,
          disciplineTypeId: val.disciplineTypeId,
          documentTypeId: val.documentTypeId,
          comment: val.comment,
          administrator: val.adminBy,
          serviceTypeName: val.serviceTypeName,
          status: val.status,
        });
      });

      this.$emit('files', this.file.tempFileUpload);
    },
    loadExistingDocuments() {
      if (this.documents != null) {
        let { files, types } = this.documents;
        this.file.tempFileUpload.files = files || [];
        this.file.tempFileUpload.types = types || [];
      }
    },
    selectedEvaluationsModalOpen() {
      this.$refs.selectedEvaluationsModalRef.show();
    },
    async getAvailablesDocuments() {
      const {
        data: response,
      } = await transitionStudentService.getAvailableDocument(
        this.studentSieId,
        null
      );
      this.availableDocumentBackup = response;
    },
    docUpdateList(selected, removed) {
      const originalFiles = [...this.file.tempFileUpload.files];
      let filteredDocs = this.file.tempFileUpload.types.filter((aviabeItem) =>
        selected.some(
          (computedItem) =>
            computedItem.value == aviabeItem.value ||
            (computedItem.text ==
              moment(aviabeItem.documentRawDate).format('DD/MMM/YYYY') +
                ' - ' +
                aviabeItem.disciplineTypeName &&
              computedItem.administrator == aviabeItem.adminBy)
        )
      );
      let filteredFiles = this.file.tempFileUpload.files.filter((aviabeItem) =>
        selected.some(
          (computedItem) =>
            computedItem.value == aviabeItem.value ||
            (computedItem.text ==
              moment(aviabeItem.documentRawDate).format('DD/MMM/YYYY') +
                ' - ' +
                aviabeItem.disciplineTypeName &&
              computedItem.administrator == aviabeItem.adminBy)
        )
      );
      originalFiles.forEach((file) => {
        const stillExists = filteredFiles.some((f) => f.id === file.id);
        if (!stillExists && !file.newlySelected && file.inServer && file.id) {
          this.$emit('remove', file.id);
        }
      });
      this.file.tempFileUpload.types = filteredDocs;
      this.file.tempFileUpload.files = filteredFiles;
      selected.forEach((val) => {
        const exists = this.file.tempFileUpload.types.some(
          (existingVal) =>
            existingVal.studentEvaluationsDocumentIds ===
              val.studentEvaluationsDocumentIds &&
            existingVal.administrator === val.adminBy
        );
        if (!exists) {
          this.file.tempFileUpload.types.push({
            newlySelected: true,
            documentDate: val.documentDate,
            documentId: val.studentEvaluationsDocumentIds,
            inServer: true,
            documentRawDate: val.documentDate,
            disciplineTypeName: val.disciplineTypeName,
            disciplineTypeId: val.disciplineTypeId,
            documentTypeId: val.documentTypeId,
            comment: val.comment,
            administrator: val.adminBy,
            serviceTypeName: val.serviceTypeName,
            status: val.status,
          });
          this.file.tempFileUpload.files.push({
            newlySelected: true,
            id: val.studentEvaluationsDocumentIds,
            inServer: val.inServer == undefined ? true : val.inServer,
            attachment: val.attachment,
            documentDate: val.documentDate,
            documentRawDate: val.documentDate,
            disciplineTypeName: val.disciplineTypeName,
            disciplineTypeId: val.disciplineTypeId,
            documentTypeId: val.documentTypeId,
            comment: val.comment,
            administrator: val.adminBy,
            serviceTypeName: val.serviceTypeName,
            status: val.status,
          });
        }
      });
      this.$emit('files', this.file.tempFileUpload);
    },
  },
  computed: {
    cmpIndex() {
      return this.objKey;
    },
    studentSieId() {
      return this.studentSieIdProp
        ? this.studentSieIdProp
        : this.$store.getters.SelectedStudent.studentId;
    },
    errorMsgTypeDocument() {
      return this.resources['150'];
    },
    computedAvailableListDocument() {
      let filteredDocs = this.availableDocumentBackup.filter(
        (aviabeItem) =>
          !this.computedAdded.some(
            (computedItem) =>
              computedItem.value === aviabeItem.value ||
              (computedItem.text === aviabeItem.text &&
                computedItem.adminBy === aviabeItem.adminBy)
          )
      );
      let alternaDoc = this.alternaDocuments.filter((aviabeItem) =>
        this.computedAdded.some(
          (computedItem) =>
            computedItem.value === aviabeItem.value ||
            (computedItem.text === aviabeItem.text &&
              computedItem.adminBy === aviabeItem.adminBy)
        )
      );

      if (alternaDoc.length == 0) {
        filteredDocs = filteredDocs.concat(this.alternaDocuments);
      }

      return filteredDocs;
    },
    computedAdded() {
      return this.file.tempFileUpload.types.map((x, index) => ({
        text:
          moment(x.documentRawDate).format('DD/MMM/YYYY') +
          ' - ' +
          x.disciplineTypeName,
        documentDate: x.documentDate,
        documentRawDate: x.documentDate,
        disciplineTypeName: x.disciplineTypeName,
        disciplineTypeId: x.disciplineTypeId,
        documentTypeId: x.documentTypeId,
        comment: x.comment,
        studentEvaluationsDocumentIds: x.studentEvaluationsDocumentIds,
        adminBy: x.administrator,
        value: `${index}`,
        serviceTypeName: x.serviceTypeName,
        status: x.status,
      }));
    },
    errorMsgFileRequired() {
      return this.resources['22124'];
    },
    actionsFiltered() {
      if (this.readOnly) return [];
      if (!this.disabled) return this.file.documentActions;

      return this.file.documentActions.filter((item) => {
        return item.disabledOnView == false;
      });
    },
  },
  async mounted() {
    this.loadResources();
    this.loadExistingDocuments();
    this.getDisciplineTypeList();
    if (!this.show) {
      await this.getAvailablesDocuments();
    }
    this.getDocumentsSelected();
  },
};
</script>

<style scope>
.zi-100 {
  z-index: 100;
}

.orange-icon {
  color: #ff7058;
}
.hidden {
  display: none;
}
.p-title {
  text-align: left;
  font-family: 'Lato';
  font-size: 16px;
}
.p-title.title-header {
  font-weight: bold;
}
.info > .center-box {
  float: left;
}
.danger-text {
  color: #e85c5c;
}
.green-icon {
  color: #2db782;
}
.panel-row-parent {
  background: #fafbfa 0% 0% no-repeat padding-box;
}
.buttons-container {
  margin-top: 29px;
}
.bg-add-panel {
  background-color: #fafafa;
  padding: 30px;
}
</style>
